import React, { useState, useEffect, useRef } from 'react';

const colorGroups = {
    Warm: ['#FF5733', '#FFC300', '#FFAE42', '#FFA500', '#FF7034', '#FE6F5E', '#FF5349', '#FF0000', '#D10047', '#FF43A4'],
    Cool: ['#00FFFF', '#0095B6', '#87CEEB', '#40E0D0', '#008080', '#7FFFD4', '#00CED1', '#50C878', '#2E8B57', '#0000FF'],
    Neutral: ['#000000', '#FFFFFF', '#808080', '#D2B48C', '#A52A2A']
};

export default function ColorSwatchPicker({ selectedColor, onSelect }) {
    const [showPopover, setShowPopover] = useState(false);
    const popoverRef = useRef(null);

    // Close popover when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (popoverRef.current && !popoverRef.current.contains(event.target)) {
                setShowPopover(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className="relative inline-block">
            {/* Inline swatches (first 3 per group) */}
            <div className="flex flex-wrap gap-8 mb-2">
                {Object.entries(colorGroups).map(([groupName, colors]) => (
                    <div key={groupName} className="flex flex-col items-start gap-1">
                        <p className="text-sm font-semibold">{groupName}</p>
                        <div className="flex gap-2">
                            {colors.slice(0, 3).map((color, index) => (
                                <button
                                    key={index}
                                    title={color}
                                    className={`w-6 h-6 rounded-full border-2 ${selectedColor === color
                                            ? color === '#FFFFFF'
                                                ? 'border-gray-400'
                                                : 'border-black'
                                            : 'border-transparent'
                                        }`}
                                    style={{ backgroundColor: color }}
                                    onClick={() => onSelect(color)}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            {/* Popover trigger */}
            <button
                className="text-sm text-blue-600 hover:underline"
                onClick={() => setShowPopover(true)}
            >
                Show more colors
            </button>

            {/* Popover Panel */}
            {showPopover && (
                <div
                    ref={popoverRef}
                    className="absolute z-50 bottom-full mb-2 p-4 bg-white border border-gray-200 rounded shadow-lg"
                >
                    <div className="flex flex-wrap gap-8 max-w-xs">
                        {Object.entries(colorGroups).map(([groupName, colors]) => (
                            <div key={groupName} className="flex flex-col items-start gap-1">
                                <p className="text-sm font-semibold">{groupName}</p>
                                <div className="flex flex-wrap gap-2">
                                    {colors.map((color, index) => (
                                        <button
                                            key={index}
                                            title={color}
                                            className={`w-6 h-6 rounded-full border-2 ${selectedColor === color
                                                    ? color === '#FFFFFF'
                                                        ? 'border-gray-400'
                                                        : 'border-black'
                                                    : 'border-transparent'
                                                }`}
                                            style={{ backgroundColor: color }}
                                            onClick={() => {
                                                onSelect(color);
                                                setShowPopover(false);
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    <button
                        className="mt-3 text-xs text-gray-600 hover:underline"
                        onClick={() => setShowPopover(false)}
                    >
                        × Close
                    </button>
                </div>
            )}
        </div>
    );
}
